var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('deferred-actions',{attrs:{"message":this.$t('successMessages.alertHandled'),"timeout":30000,"open-action":function () { return _vm.handleOrUndoAlert(); },"timeout-action":function () { return _vm.hideAlertIfNecessary(); },"actions":{
        undo : {
          label : this.$t('dss.undo'),
          action : function () { return _vm.handleOrUndoAlert(true); }
        },
   },"toast-options":{
      icon: 'undo'
   }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
   var defer = ref.defer;
return [(_vm.state === 'handled' || _vm.handled)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
   var on = ref.on;
   var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"handle-alert-button__icon ml-6",attrs:{"color":"green","dark":""}},'v-icon',attrs,false),on),[_vm._v(" mdi-check-bold ")])]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$t('alert.handled')))])]):_c('v-btn',{staticClass:"ml-4",attrs:{"fab":"","text":"","small":"","right":"","color":"red","disabled":_vm.hasReadOnlyAccess},on:{"click":defer}},[_c('v-icon',{staticClass:"handle-alert-button__icon",attrs:{"dark":""}},[_vm._v(" mdi-close ")])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }